import React from 'react'
import OverviewTable from './OverviewTable'

export default function SubCategoryOverviewTable() {
  return <OverviewTable module="SUBCATEGORY" redirect="subcategory" />
}
